export default class ModuleLoader {
    private loadedModules = {};

    constructor(private selector: string) {
        const isDevelopment = document.documentElement.hasAttribute('development');
        isDevelopment
            ? document.body.onload = () => this.initModules()
            : this.initModules();
    }

    initModules(selector: string = this.selector): void {
        const moduleNames = this.getModuleNames(selector);

        Promise.all(this.getModuleListToLoad(moduleNames))
            .then(() => this.fireEventAfterModluesInit());
    }

    private getModuleListToLoad(moduleNames: string[]): Promise<any>[] {
        return moduleNames.map(name => this.loadModule(name));
    }

    private loadModule(moduleName: string): Promise<any> {
        return this.isModuleInStore(moduleName)
            ? this.runModuleFromStore(moduleName)
            : this.importModule(moduleName);
    }

    private importModule(moduleName: string): any {
        return import(/* webpackChunkName: "[request]" */'./modules/' + moduleName)
            .then((module) => this.loadedModules[moduleName] = module.default);
    }

    private runModuleFromStore(moduleName: string): ModuleLoader {
        this.loadedModules[moduleName].setup();
        return this;
    }

    private isModuleInStore(moduleName: string): boolean {
        return !!this.loadedModules[moduleName];
    }

    private getModuleNames(selector: string): string[] {
        const dataSelector = this.getDataSelector(selector),
            modules = document.querySelectorAll(selector);

        return Array.from(modules).reduce((acc, node: HTMLElement) => {
            const moduleName = node.dataset[dataSelector];

            if (moduleName && !acc.includes(moduleName) && this.isNodeInitialized(node)) {
                acc.push(moduleName);
            }

            return acc;
        }, []);
    }

    private isNodeInitialized(node: HTMLElement): boolean {
        return !node.dataset.moduleInitialized;
    }

    private getDataSelector(selector: string): string {
        return selector.match(/data-(\w+)/)[1];
    }

    private fireEventAfterModluesInit(): ModuleLoader {
        document.dispatchEvent(new CustomEvent('elearning:modulesloaded'));
        return this;
    }
}
